<template>
  <main id="content" class="grid-x resume-page">
    <article class="main cell
                    small-offset-0
                    medium-offset-1 medium-9
                    middle-offset-3 middle-7">

      <h1 class="intro-text">Workalicious is the Web Development & Design Shop of Dave Kaplan.</h1>

      <address class="work-address">
        <p>Contact information:</p>
        <a href="mailto:work@workalicious.com">work@workalicious.com</a> <br>
        <a href="tel:+17735975001">773-597-5001</a>
      </address>

      <p class="">Dave was educated in art and graphic design. He's worked in different roles related to web and interactive media for over 10 years. Before the web, he worked as graphic designer and print production specialist.</p>

      <p class="">His primary focus in the past few years has been front-end development and html5 animated display advertising. Both extensions of years of experience with Flash and Actionscript. Dave considers himself to be a developer with designer's point of view, and he'll move stuff by a pixel or 2 when necessary.</p>

      <p class="">Dave got his start creating interactive media and animation early on with Shockwave and Macromedia Flash. Mainly focused now on HTML, CSS, Javascript, and animating with Greensock's GSAP. Very recently he's started building Single Page Apps like this site and Range Design's site using Vue.js. He's got no Angular and no React experience, yet, he decided to start with Vue.js.</p>

      <p class="">A long-time PHP hacker and WordPress wrangler, he did a Rails bootcamp and played with Ruby and Rails, but does not consider himself a Ruby or Rails developer. Dave is currently focusing his work on design and development with VueJS and WordPress, together and separately.</p>

      <p class="note">References provided upon request.</p>

      <h2>2016—present<br>SCA Facility Websites: WordPress Multisite Network</h2>
      <p>
        Surgical Care Affiliates (SCA) is one of the largest providers of outpatient surgery in the United States with a
        network of more than 200 surgery centers.
      </p>

      <p>
        As a subcontractor for Dept-11, I have had the opportunity to design and develop a WordPress Multisite Network
        for
        SCA. The goal was to create responsive website template with a content management system that could be
        administered by the various centers. There are currently around 130 affiliates utilizing the template on the SCA
        WordPress Network.
      </p>

      <p>
        I am working as a designer-developer on the SCA Network. I handled the design, design-production, front end
        development, server configuration and management. I’ve also provided support and training for the centers using
        the template. We are currently working through WCAG compliance and bringing more centers onto the template. The
        template theme is a customized version Automatic’s starter theme, Underscores.
      </p>

      <p>
        In addition to the visual design and front-end development, I configured a local, staging and production
        environment to do my work. The stack is Apache 2.4, PHP 7.x+ and MariaDB. Locally, I use Vagrant and VMware
        Fusion to match the Staging and Production environments.
      </p>

      <hr>

      <h2>
        2015—present<br>
        Various Clients: HTML5 Display Banner Ad Development
      </h2>

      <p>
        Development and production for HTML5 Display Banners with HTML, JavaScript and CSS. I create these ads using a
        TextEditor (Sublime or WebStorm) and usually work from a creative team’s Photoshop file.
      </p>

      <p>
        Often these ads have file size constraints and I work toward developing the best looking ad while meeting the
        required spec. It can be a challenge to get all the images saved at a high quality, but years of experience with
        design and design production makes this an area of expertise for me. I’ve also been using Greensock’s animation
        platform since the ActionScript Flash days and continue to use Greensock’s JS version.
      </p>

      <p>
        I have experience working with Flashtalking’s Dynamic Ad Platform, DoubleClick Studio, Sizmek, and Conversant.
      </p>

      <h3>Clients include: </h3>
      <ul>
        <li>Arc Worldwide/Frequency540</li>
        <li>MatchMG/Trisect</li>
        <li>Downtown Partners - Chicago,</li>
        <li>Sponge Chicago</li>
        <li>Flashtalking</li>
      </ul>
      <h4>Brands include:</h4>
      <ul>
        <li>U.S. Cellular</li>
        <li>Conagra (various food and snack-food brands)</li>
        <li>Chamberlain</li>
        <li>The Private Bank / CIBC</li>
        <li>Quaker Oats</li>
        <li>Corner Bakery</li>
        <li>Regional Transportation Authority (RTA)</li>
        <li>Feeding America</li>
        <li>Presence Health</li>
      </ul>

      <h2>
        May 2008—2012<br>
        Independent Contractor: Flash Developer, Y&R Brands
      </h2>
      <p>Web design and development, primarily Flash-based. Development of dynamic Flash sites driven with a custom Content Management System (CMS) backend with PHP/mySQL and XML.</p>

      <h2>
        05/2005—2012<br>
        Various Clients: Web Development
      </h2>
      <p>Web design and development, primarily Flash-based. Development of dynamic Flash sites driven with a custom Content Management System (CMS) backend with PHP/mySQL and XML.</p>

      <h2>
        05/2005—2006<br>
        Freelance Interactive Graphic & Production Design, Arc Worldwide
      </h2>
      <p>In my year at ARC Worldwide, I provided design and production for Cadillac.com, Whirlpool.com and thebar.com.</p>

      <h2>
        02/2004 — 04/2005<br>
        Senior Art Director, Euro RSCG 4D
      </h2>
      <p>Euro RSCG 4D, a direct marketing agency, thrives on measurable results and strategic thinking. At Euro, teamed with copywriters, we developed concepts for direct mail, interactive marketing, and POS materials for Citibank, Shell, Sears, and AARP. Direct market understanding, the ability to handle aggressive timelines and multiple projects were also inherent to my position. In addition to my usual workload, I also worked as part of a team developing creative for new business pitches.</p>

      <h2>
        10/2003—01/2004<br>
        Freelance Graphic & Production Specialist, iLeo
      </h2>
      <p>High resolution photo retouching, color correction, keylining, digital assembly, and file preparation for the Starbucks outdoor and print campaigns.</p>

      <h2>
        10/1999 — 08/2003<br>
        Senior Designer & Flash Developer, Tanagram Partners
      </h2>
      <p>Worked on a variety of print and web-based projects. Served as integral member of a team for the development and implementation of graphic systems, contributed to all stages of the process, from the conceptual design phase to the final production. Flash Development & Actionscript for client web sites. Established and maintained several client sub-domains for project presentations.</p>

      <h2>
        10/1998 — 09/1999<br>
        Production Studio, Brann Worldwide
      </h2>
      <p>Direct Marketing Production Studio doing work for Sears and Visa. In addition to the responsibilities related to preparing files for release to a printer, I spent many hours working with type sizes barely visible to the human eye. Managed work load for 2nd shift. Worked to clear projects for 1st shift. Most often, the morning crew could come in and everything would be done.</p>

      <h2>
        05/1997—10/1998<br>
        Graphic Designer, Freelance
      </h2>
      <p>Worked in a variety of settings, from a 1 person of office to a large textbook publisher. Including: Ward Nipper Communication, Jane Barber Design, National Textbook Company & MHC Contemporary, and Brann Worldwide.</p>

      <h2>
        10/1995—10/1997<br>
        Graphic Designer, Tanagram
      </h2>
      <p>Some of the client projects I worked on were for Motorola, Niketown, and Spiegel. Played a supporting
        role for the senior designers and creative directors. It was at this time that I started building interactive communication design pieces using Macromedia Director. I also worked on a variety of print projects. There was an emphasis on conceptual design, great typography, and solid hand skills.</p>

      <h2>
        06/1993—10/1995<br>
        Graphic Designer & Screenprinter, SuperBest
      </h2>
      <p>An independent study lead to a leave of absence from the School of the Art Institute of Chicago to start up
        a young men's sportswear company. My partner and I designed the clothing and visuals surrounding the SuperBest Brand. We designed and printed are own t-shirts. Attended several trade shows, where we sold the line to small clothing boutiques around the US and a company exporting to Japan. While at SuperBest, I taught myself to screenprint.</p>


    </article>
  </main>
</template>

<script>
  export default {}
</script>

<style lang="scss">
  @import '~foundation-sites/scss/foundation.scss';
  @import '../css/settings';
  @import '../css/colors';

  .background-light {
    h1, h2, h3, h4 {
      color: $deepRed;
      font-size: 18px;
      font-family: "Verlag A", "Verlag B", sans-serif;
      font-style: normal;
      font-weight: 700;

      .work-external-link {
        /*position: relative;*/
        color: $deepBlue;

        &:hover {
          color: $deepHaze;
          text-decoration: underline;
        }
        &::after {
          /*position: absolute;*/
          /*top: 8px;*/
          content: "\f010";
          padding-left: .4rem;
          font-family: 'SocialBrands-Regular', sans-serif;
          font-size: 1rem;
          font-weight: normal;
          speak: none;
        }
      }
    }
  }

  .resume-page {
    padding-bottom: 3rem;
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 2%;
    line-height: 1;

    p, ul {
      color: $deepBlack;
      font-family: "Chronicle SSm A", "Chronicle SSm B", sans-serif;
      font-style: normal;
      font-weight: 400;
      /*font-size: 1rem;*/
      padding-right: 3rem;
    }
  }

  h1.intro-text {
    color: $deepPewter;
    font-family: "Verlag A", "Verlag B", sans-serif;
    font-style: normal;
    font-weight: 700;
  }

  .note {
    font-style: italic !important;
    font-size: .9rem;
  }



  .work-address {
    p, a {
      margin: 0;
      font-size: 1rem;
      line-height: 1.4;
      font-family: "Verlag A", "Verlag B", sans-serif;
      font-style: normal;
      font-weight: 700;
      color: $deepRed;
    }
    p {
      color: $deepPewter;
    }
    margin: 10px 0;
  }



</style>



// WEBPACK FOOTER //
// src/components/Experience.vue